import { useEffect, useState } from "react";
import api from "../api/axios";
import { FaShoppingCart, FaMoneyBillWave, FaCheckCircle, FaUsers, FaChartLine } from "react-icons/fa";
import AlertBox from "../components/AlertBox";
import { useTranslation } from "react-i18next"; // الترجمة

export default function AdminDashboard() {
    const { t } = useTranslation(); // تفعيل
    const [stats, setStats] = useState(null);
    const [err, setErr] = useState("");

    useEffect(() => {
        api.get("/dashboard/stats")
            .then((res) => {
                const payload = res.data.data ?? res.data;
                setStats(payload.data ?? payload);
            })
            .catch((e) => {
                setErr(e.response?.data?.message || t("admin_dash_load_failed"));
            });
    }, [t]);

    if (err) {
        return (
            <div className="container-fluid py-4">
                <AlertBox type="danger" message={err} onClose={() => setErr("")} />
            </div>
        );
    }

    if (!stats) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} />
            </div>
        );
    }

    return (
        <div className="container-fluid p-0 pb-5">
            <div className="d-flex align-items-center mb-4 border-bottom pb-3">
                <FaChartLine className="fs-3 text-primary me-3" />
                <h2 className="m-0 fw-bold text-dark">{t("admin_dash_overview")}</h2>
            </div>

            <div className="row g-4 mb-5">
                <div className="col-12 col-md-6 col-xl-3">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 hover-lift" style={{ background: "linear-gradient(135deg, #4e73df 0%, #224abe 100%)" }}>
                        <div className="card-body p-4 position-relative text-white">
                            <h6 className="text-uppercase fw-bold text-white-50 mb-1">{t("admin_dash_total_orders")}</h6>
                            <h2 className="display-5 fw-bold mb-0">{stats.total_orders}</h2>
                            <FaShoppingCart className="position-absolute opacity-25" style={{ fontSize: "5rem", bottom: "10px", right: "10px" }} />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 hover-lift" style={{ background: "linear-gradient(135deg, #1cc88a 0%, #13855c 100%)" }}>
                        <div className="card-body p-4 position-relative text-white">
                            <h6 className="text-uppercase fw-bold text-white-50 mb-1">{t("admin_dash_paid_orders")}</h6>
                            <h2 className="display-5 fw-bold mb-0">{stats.paid_orders}</h2>
                            <FaCheckCircle className="position-absolute opacity-25" style={{ fontSize: "5rem", bottom: "10px", right: "10px" }} />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 hover-lift" style={{ background: "linear-gradient(135deg, #f6c23e 0%, #dda20a 100%)" }}>
                        <div className="card-body p-4 position-relative text-dark">
                            <h6 className="text-uppercase fw-bold opacity-75 mb-1">{t("admin_dash_total_revenue")}</h6>
                            <h2 className="display-5 fw-bold mb-0">${stats.revenue}</h2>
                            <FaMoneyBillWave className="position-absolute opacity-25" style={{ fontSize: "5rem", bottom: "10px", right: "10px" }} />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 hover-lift" style={{ background: "linear-gradient(135deg, #36b9cc 0%, #258391 100%)" }}>
                        <div className="card-body p-4 position-relative text-white">
                            <h6 className="text-uppercase fw-bold text-white-50 mb-1">{t("admin_dash_users")}</h6>
                            <h2 className="display-5 fw-bold mb-0">{stats.total_users ?? "0"}</h2>
                            <FaUsers className="position-absolute opacity-25" style={{ fontSize: "5rem", bottom: "10px", right: "10px" }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card border-0 shadow-sm rounded-4">
                <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                    <h5 className="fw-bold mb-0">{t("admin_dash_status")}</h5>
                </div>
                <div className="card-body mt-2">
                    <div className="alert alert-light border m-0">
                        <p className="text-muted m-0 fs-6">
                            {t("admin_dash_status_desc")}
                        </p>
                    </div>
                </div>
            </div>

            <style>{`
                .hover-lift { transition: transform 0.2s ease-in-out; }
                .hover-lift:hover { transform: translateY(-5px); box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important; }
            `}</style>
        </div>
    );
}